import {loadHeader} from "./misc/header";
import {loadCommonElementLogic} from "./misc/common-element-logic";
import {hasClickMenuTag, loadClickMenu} from "./click-menu/click-menu";
import {hasListingRowTag, loadListingRow} from "./list/listing-row";
import {hasDatePicker, loadDatePicker} from "../classes/misc/date-picker";
import {hasFormInputs, loadForms} from "./form/forms";
import {hasFormButtons, loadFormButtons} from "./form/form-buttons";
import {hasProgbar, loadProgbar} from "../classes/misc/progbar";
import {hasDbMenu, loadDbMenu} from "../classes/misc/db-menu";
import {loadListPage} from "./list/list-page";

export function setupPage() {
    if (!GlobalEnt.pageData) {
        return;
    }

    loadHeader();
    loadCommonElementLogic();

    if (hasDatePicker())
        loadDatePicker();

    if (hasFormInputs())
        loadForms();

    if (hasFormButtons())
        loadFormButtons();

    if (hasProgbar())
        loadProgbar();

    if (hasDbMenu())
        loadDbMenu();

    if (hasClickMenuTag())
        loadClickMenu();

    if (hasListingRowTag())
        loadListingRow();

    if (document.querySelector('.listing-table'))
        loadListPage();
}